import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/packingFunctions.js
var name, shader, packingFunctions;
var init_packingFunctions = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/packingFunctions.js"() {
    init_shaderStore();
    name = "packingFunctions";
    shader = `vec4 pack(float depth)
{const vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const vec4 bit_mask=vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}
float unpack(vec4 color)
{const vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(color,bit_shift);}`;
    ShaderStore.IncludesShadersStore[name] = shader;
    packingFunctions = { name, shader };
  }
});

export {
  packingFunctions,
  init_packingFunctions
};
